import React from 'react';
import styled from 'styled-components';
import {
    TiSocialFacebook,
    TiSocialYoutube,
    TiSocialInstagram,
} from 'react-icons/ti';
import vars from '../lib/styled';
import lang from '../../static/lang.json';
import LocaleContext from './Locale';

const Floating = styled.div`
    align-items: center;
    display: flex;
    color: #fff;
    left: 1.5rem;
    bottom: 2rem;
    width: 350px;
    z-index: 10;

    @media (min-width: ${vars.breakpoint.desktop}) {
        left: 2rem;
    }

    @media (max-width: ${vars.breakpoint.laptop}) {
        left: 1rem;
    }

    @media (max-width: ${vars.breakpoint.tablet}) {
        min-width: 100%;
        align-items: center;
        justify-content: center;
        text-align: center;
        width: 100%;
    }
`;

const Line = styled.span`
    background-color: #fff;
    display: inline-block;
    margin: 0 1rem;
    height: 2px;
    width: 50px;
`;

const SocialLink = styled.a.attrs({
    target: '_blank',
})`
    color: #fff;
    margin-right: 1rem;
    transition: transform 350ms;

    &:hover {
        transform: scale(1.1);
    }
`;

export default () => (
    <LocaleContext.Consumer>
        {({ locale }) => (
            <Floating>
                <span>{lang.follow[locale]}</span>
                <Line />
                <SocialLink
                    href="https://www.facebook.com/marcangelofoods/"
                    aria-label="Facebook"
                >
                    <TiSocialFacebook aria-hidden={true} size="1.5em" />
                </SocialLink>
                <SocialLink
                    href="https://www.youtube.com/channel/UCwtSlUFxnddW1KmBzP11YnQ"
                    aria-label="YouTube"
                >
                    <TiSocialYoutube aria-hidden={true} size="1.5em" />
                </SocialLink>
                <SocialLink
                    href="https://www.instagram.com/marcangelofoods/"
                    aria-label="Instagram"
                >
                    <TiSocialInstagram size="1.5em" />
                </SocialLink>
            </Floating>
        )}
    </LocaleContext.Consumer>
);
